import type { HTMLProps } from 'react';

const Div = ({ children, ...props }: HTMLProps<HTMLDivElement>) => {
    return <div {...props}>{children}</div>;
};

export default Div;
